import { Button, Modal, Space } from "@mantine/core";
import {
  useIsAssignmentOwner,
  useUserDidConsentToAssignment,
} from "@/store/selectors/assignmentSelectors";
import { useActiveAssignment } from "@/store/selectors/assignmentSelectors";
import { Navigation } from "@/services/Navigation";
import { Text } from "../ui/Text";
import { AssignmentService } from "@/services/AssignmentService";
import { useActiveUser } from "@/store/selectors";
import { useIsStudentApp } from "@/store/selectors/featureSelectors";
import { useMemo, useState } from "react";
import { TextInput } from "../ui/TextInput";
import { UserProfileService } from "@/services/UserProfileService";

export function AssignmentConsentConfirmation() {
  const activeAssignment = useActiveAssignment();
  const userDidConsentToAssignment = useUserDidConsentToAssignment({
    assignmentId: activeAssignment?.id || "",
  });

  const isStudentApp = useIsStudentApp();
  const isAssignmentOwner = useIsAssignmentOwner();
  const activeUser = useActiveUser();
  const [name, setName] = useState(activeUser?.name || "");

  const UserNameInput = useMemo(() => {
    return (
      <TextInput
        id="name"
        title="Name"
        placeholder="Enter your full name"
        value={name}
        onDebouncedChange={(value) => {
          setName(value);
          UserProfileService.updateUserName({ name: value });
        }}
      />
    );
  }, [name]);

  if (!isStudentApp || isAssignmentOwner) {
    return null;
  }

  return (
    <Modal
      centered
      title="Assignment Consent Confirmation"
      opened={!!activeAssignment && !userDidConsentToAssignment}
      size="md"
      styles={{
        header: {
          paddingLeft: 24,
          paddingRight: 24,
        },
        body: {
          paddingLeft: 24,
          paddingRight: 24,
        },
        title: {
          fontSize: 18,
          fontWeight: 600,
        },
      }}
      onClose={() => {
        Navigation.navigate("/");
      }}
    >
      <Text>
        Heads up! The creator of this assignment will be able to see your email
        address and data related to this assignment.
      </Text>

      <Space h="sm" />
      <Text>
        Given the above, do you want to continue with the assignment?{" "}
        <span style={{ fontWeight: 600 }}>
          Enter your full name to confirm.
        </span>
      </Text>
      <Space h="sm" />
      {UserNameInput}
      <Space h="lg" />
      <Button
        fullWidth
        color="primary"
        radius="xl"
        disabled={name.trim()?.length < 3}
        onClick={() => {
          if (!activeAssignment || !activeUser) {
            return;
          }
          AssignmentService.updateUserAssignmentConsent({
            assignment: activeAssignment,
            studentUserId: activeUser?.id,
          });
        }}
      >
        Yes, continue to assignment
      </Button>
      <Space h="xs" />
      <Button
        fullWidth
        color="primary"
        radius="xl"
        variant="subtle"
        onClick={() => {
          if (!activeAssignment || !activeUser) {
            return;
          }

          Navigation.navigate("/");

          setTimeout(() => {
            AssignmentService.handleUserConsentReject({
              assignment: activeAssignment,
              studentUserId: activeUser?.id,
            });
          }, 1000);
        }}
      >
        No, I don't want to continue
      </Button>
    </Modal>
  );
}
